import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';

interface RedirectIfIncompleteRegistrationProps {
  children: React.ReactNode;
}

const RedirectIfIncompleteRegistration: React.FC<RedirectIfIncompleteRegistrationProps> = ({ children }) => {
  const { user, needsProfileCompletion } = useAuth();
  const location = useLocation();
  
  // Check if path is already complete-registration
  const isAlreadyOnCompletionPage = location.pathname === '/complete-registration';
  
  // If user needs profile completion and isn't already on the completion page
  if (user && needsProfileCompletion && !isAlreadyOnCompletionPage) {
    return <Navigate to="/complete-registration" replace />;
  }
  
  // If user is on the completion page but doesn't need profile completion
  if (user && !needsProfileCompletion && isAlreadyOnCompletionPage) {
    return <Navigate to="/hub" replace />;
  }
  
  return <>{children}</>;
};

export default RedirectIfIncompleteRegistration;